import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {size2Like, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            correlation: anyImageOpResult,
            // offsetImage: anyImageOpResult,
            offset: vector2Like,
            referencePosition: vector2Like,
            imageSize: size2Like,
            level: z.number(),
            penaltyPerPixel: vector2Like, // in each direction
            penaltyDirectionX: vector2Like.optional(), // image-space direction of the x-component of the penalty
        }),
    },
}
